var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1643 32.4163C34.6786 32.4163 39.9595 27.1354 39.9595 20.6211C39.9595 14.1068 34.6786 8.82587 28.1643 8.82587C21.65 8.82587 16.3691 14.1068 16.3691 20.6211C16.3691 27.1354 21.65 32.4163 28.1643 32.4163Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_803_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 8.43457C21.4007 8.43457 16 13.7887 16 20.3929C16 26.9972 21.4007 32.3513 28.0625 32.3513C34.7242 32.3513 40.1249 26.9972 40.1249 20.3929C40.1249 13.7887 34.7242 8.43457 28.0625 8.43457ZM32.1298 22.409L34.1634 24.4251L32.1298 26.4412L30.0961 24.4251L28.0625 22.409L26.0288 24.4251L23.9952 26.4412L21.9615 24.4251L23.9952 22.409L26.0288 20.3929L23.9952 18.3768L21.9615 16.3607L23.9952 14.3446L26.0288 16.3607L28.0625 18.3768L30.0961 16.3607L32.1298 14.3446L34.1634 16.3607L32.1298 18.3768L30.0961 20.3929L32.1298 22.409Z",
    fill: "#B90101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_803_110",
    x: 0,
    y: 0.43457,
    width: 56.125,
    height: 55.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.137255 0 0 0 0 0.247059 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_803_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_803_110",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExit);
export default __webpack_public_path__ + "static/media/red-exit.23e6b139e7c12a2bdc7a7725fdd542e6.svg";
export { ForwardRef as ReactComponent };